var _path, _g, _path2, _g2, _path3, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleOfPossibilities4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 84,
    viewBox: "0 0 88 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_16_2041)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_2041",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 139,
    height: 139
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.4999 1.52588e-05C31.1156 1.52588e-05 0.000732422 31.1162 0.000732422 69.5001C0.000732422 107.884 31.1156 139 69.4999 139C107.883 139 138.999 107.884 138.999 69.5001C138.999 31.1162 107.883 1.52588e-05 69.4999 1.52588e-05ZM15.4917 69.5001C15.4917 39.6719 39.6713 15.4916 69.4999 15.4916C99.3277 15.4916 123.508 39.6719 123.508 69.5001C123.508 99.3283 99.3277 123.508 69.4999 123.508C39.6713 123.508 15.4917 99.3283 15.4917 69.5001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_2041)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 69.1157H0V69.8843H139V69.1157Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.355 60.0475L0.544434 78.1907L0.644751 78.9526L138.456 60.8095L138.355 60.0475Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.532 51.141L2.26868 87.1168L2.46759 87.8591L136.731 51.8834L136.532 51.141Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.562 42.5484L5.14331 95.7415L5.43742 96.4515L133.857 43.2585L133.562 42.5484Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.497 34.4173L9.11914 103.917L9.50342 104.583L129.881 35.0829L129.497 34.4173Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.404 26.8862L14.1281 111.504L14.5959 112.114L124.872 27.496L124.404 26.8862Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.372 20.0843L20.0844 118.372L20.6278 118.916L118.916 20.6278L118.372 20.0843Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.504 14.1281L26.8862 124.404L27.496 124.872L112.114 14.596L111.504 14.1281Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.917 9.11912L34.4172 129.497L35.0828 129.881L104.583 9.5034L103.917 9.11912Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7415 5.1434L42.5485 133.563L43.2585 133.857L96.4515 5.43752L95.7415 5.1434Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1166 2.26877L51.1409 136.532L51.8832 136.731L87.859 2.4677L87.1166 2.26877Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1905 0.544418L60.0474 138.355L60.8093 138.456L78.9525 0.64473L78.1905 0.544418Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1157 1.52588e-05V139H69.8843V1.52588e-05H69.1157Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0474 0.64473L78.1905 138.456L78.9525 138.355L60.8093 0.544418L60.0474 0.64473Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.141 2.4677L87.1168 136.731L87.8591 136.532L51.8834 2.26877L51.141 2.4677Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5485 5.43752L95.7415 133.857L96.4515 133.563L43.2585 5.14339L42.5485 5.43752Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4172 9.50352L103.917 129.881L104.583 129.497L35.0828 9.11924L34.4172 9.50352Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8862 14.596L111.504 124.872L112.114 124.404L27.496 14.1281L26.8862 14.596Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0844 20.6278L118.372 118.916L118.916 118.372L20.6278 20.0843L20.0844 20.6278Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1281 27.496L124.404 112.114L124.872 111.504L14.5959 26.8862L14.1281 27.496Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11914 35.0829L129.497 104.583L129.881 103.917L9.50342 34.4173L9.11914 35.0829Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14331 43.2585L133.562 96.4515L133.857 95.7415L5.43742 42.5485L5.14331 43.2585Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26868 51.8834L136.532 87.8591L136.731 87.1168L2.46759 51.141L2.26868 51.8834Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.544434 60.8095L138.355 78.9526L138.456 78.1907L0.644751 60.0475L0.544434 60.8095Z",
    fill: "#2C4C53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_16_2041",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 109,
    height: 109
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4917 69.5001C15.4917 99.3284 39.6711 123.508 69.5 123.508C99.3277 123.508 123.508 99.3284 123.508 69.5001C123.508 39.6719 99.3277 15.4916 69.5 15.4916C39.6711 15.4916 15.4917 39.6719 15.4917 69.5001ZM35.1504 69.5001C35.1504 50.529 50.529 35.1501 69.5 35.1501C88.4709 35.1501 103.85 50.529 103.85 69.5001C103.85 88.4709 88.4709 103.85 69.5 103.85C50.529 103.85 35.1504 88.4709 35.1504 69.5001Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_16_2041)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.819 64.4767L0.129517 73.7564L0.180825 74.5232L138.871 65.2436L138.819 64.4767Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.571 55.4718L1.27856 82.7746L1.42953 83.5282L137.722 56.2254L137.571 55.4718Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.157 46.7069L3.59485 91.5658L3.84288 92.2932L135.405 47.4343L135.157 46.7069Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.621 38.332L7.03894 99.9794L7.3798 100.668L131.961 39.0208L131.621 38.332Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.021 30.4901L11.5516 107.871L11.9795 108.51L127.449 31.1286L127.021 30.4901Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.437 23.3159L17.0558 115.107L17.5633 115.684L121.944 23.8931L121.437 23.3159Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.964 16.932L23.4574 121.562L24.0359 122.068L115.543 17.438L114.964 16.932Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.714 11.4474L30.6467 127.126L31.2863 127.553L108.353 11.8735L107.714 11.4474Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.8095 6.95618L38.501 131.705L39.1907 132.044L100.499 7.29517L99.8095 6.95618Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3867 3.53514L46.8855 135.219L47.6136 135.465L92.1148 3.78119L91.3867 3.53514Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5893 1.24258L55.657 137.609L56.411 137.757L83.3433 1.39149L82.5893 1.24258Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5679 0.118057L64.6654 138.833L65.4324 138.882L74.3349 0.167282L73.5679 0.118057Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4768 0.180786L73.7564 138.871L74.5233 138.819L65.2436 0.129471L64.4768 0.180786Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4719 1.42938L82.7747 137.722L83.5283 137.571L56.2255 1.27843L55.4719 1.42938Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7069 3.84286L91.5658 135.405L92.2933 135.157L47.4343 3.59483L46.7069 3.84286Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.332 7.37967L99.9794 131.961L100.668 131.62L39.0209 7.03882L38.332 7.37967Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4902 11.9794L107.872 127.449L108.51 127.021L31.1287 11.5516L30.4902 11.9794Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.316 17.5634L115.107 121.944L115.684 121.437L23.8932 17.0558L23.316 17.5634Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9321 24.0357L121.562 115.543L122.068 114.964L17.4381 23.4572L16.9321 24.0357Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4475 31.2864L127.127 108.353L127.553 107.714L11.8736 30.6467L11.4475 31.2864Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95618 39.1907L131.705 100.499L132.044 99.8095L7.29516 38.501L6.95618 39.1907Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53528 47.6135L135.219 92.1146L135.465 91.3865L3.78133 46.8854L3.53528 47.6135Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24268 56.4109L137.609 83.3431L137.758 82.5891L1.39159 55.6569L1.24268 56.4109Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.118164 65.4323L138.833 74.3348L138.882 73.5679L0.167388 64.6654L0.118164 65.4323Z",
    fill: "#2C4C53"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_16_2041",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 35,
    width: 69,
    height: 69
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1503 69.5001C35.1503 88.4709 50.5289 103.85 69.4999 103.85C88.4708 103.85 103.849 88.4709 103.849 69.5001C103.849 50.529 88.4708 35.1501 69.4999 35.1501C50.5289 35.1501 35.1503 50.529 35.1503 69.5001ZM47.0888 69.5001C47.0888 57.1224 57.1224 47.0886 69.4999 47.0886C81.8774 47.0886 91.9112 57.1224 91.9112 69.5001C91.9112 81.8777 81.8774 91.9115 69.4999 91.9115C57.1224 91.9115 47.0888 81.8777 47.0888 69.5001Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_16_2041)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 69.1157H0V69.8843H139V69.1157Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.355 60.0475L0.544434 78.1907L0.644751 78.9526L138.456 60.8095L138.355 60.0475Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.532 51.141L2.26868 87.1168L2.46759 87.8591L136.731 51.8834L136.532 51.141Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.562 42.5484L5.14331 95.7415L5.43742 96.4515L133.857 43.2585L133.562 42.5484Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.497 34.4173L9.11914 103.917L9.50342 104.583L129.881 35.0829L129.497 34.4173Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.404 26.8862L14.1281 111.504L14.5959 112.114L124.872 27.496L124.404 26.8862Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.372 20.0843L20.0844 118.372L20.6278 118.916L118.916 20.6278L118.372 20.0843Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.504 14.1281L26.8862 124.404L27.496 124.872L112.114 14.596L111.504 14.1281Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.917 9.11924L34.4172 129.497L35.0828 129.881L104.583 9.50352L103.917 9.11924Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7415 5.1434L42.5485 133.563L43.2585 133.857L96.4515 5.43752L95.7415 5.1434Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1166 2.26877L51.1409 136.532L51.8832 136.731L87.859 2.4677L87.1166 2.26877Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1906 0.544418L60.0474 138.355L60.8093 138.456L78.9525 0.64473L78.1906 0.544418Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1157 1.52588e-05V139H69.8843V1.52588e-05H69.1157Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0474 0.64473L78.1905 138.456L78.9525 138.355L60.8093 0.544418L60.0474 0.64473Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.141 2.4677L87.1168 136.731L87.8591 136.532L51.8834 2.26877L51.141 2.4677Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5485 5.43752L95.7415 133.857L96.4515 133.563L43.2585 5.14339L42.5485 5.43752Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4172 9.50352L103.917 129.881L104.583 129.497L35.0828 9.11924L34.4172 9.50352Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8862 14.596L111.504 124.872L112.114 124.404L27.496 14.1281L26.8862 14.596Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0844 20.6278L118.372 118.916L118.916 118.372L20.6278 20.0843L20.0844 20.6278Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1281 27.496L124.404 112.114L124.872 111.504L14.5959 26.8862L14.1281 27.496Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11914 35.0829L129.497 104.583L129.881 103.917L9.50342 34.4173L9.11914 35.0829Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14331 43.2585L133.562 96.4515L133.857 95.7415L5.43742 42.5485L5.14331 43.2585Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26868 51.8834L136.532 87.8591L136.731 87.1168L2.46759 51.141L2.26868 51.8834Z",
    fill: "#2C4C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.544434 60.8095L138.355 78.9526L138.456 78.1907L0.644751 60.0475L0.544434 60.8095Z",
    fill: "#2C4C53"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_2041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 139,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleOfPossibilities4);
export default __webpack_public_path__ + "static/media/circle-of-possibilities-4.824cf6ddd0c7836eb499e3c5bb044ae1.svg";
export { ForwardRef as ReactComponent };